<template>
  <div class="congestion-area">
    <div class="text">混雑度</div>
    <div class="row">
      <div>
        <ImageHorizontal img="restaurant-1.png" text="半分空き" />
        <ImageHorizontal img="restaurant-3.png" text="10分待ち" />
      </div>
      <div>
        <ImageHorizontal img="restaurant-2.png" text="待ち無し" />
        <ImageHorizontal img="restaurant-4.png" text="30分待ち" />
      </div>
      <ImageHorizontal img="restaurant-0.png" text="不明" />
    </div>
  </div>
</template>

<script>
import ImageHorizontal from '@/components/Molecules/ImageHorizontal'

export default {
  name: 'consetn-check',
  components: {
    ImageHorizontal
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
.congestion-area{
  margin: 0.5rem 0.5rem 0rem 0.5rem;
  display: flex;
}
.text{
  width: 4rem;
  font-size: 0.9rem;
  line-height: 3rem;
  margin: 0em 1em 0em 0em;
}
.row{
  width: 18rem;
  font-size: 0.9rem;
  display: flex;
  justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// src/components/Organisms/SpotCongestion.vue